import BackgroundLoading from './BackgroundLoading';

import './styles.scss'

export  const AnimationLoading =()=>{
    return(
        <div>
            <div className="container-loading">
               <div className='loading'>
                 <span>L</span>
                 <span>o</span>
                 <span>a</span>
                 <span>d</span>
                 <span>i</span>
                 <span>n</span>
                 <span>g</span>
                </div>
            </div>
            <BackgroundLoading/>
        </div>
      
      
    )
}

export default AnimationLoading;